<script>
  import { moneyFormat } from "@/utility/functions";
  import Alert from "@/utility/alert_triggers";

  export default {
    name: "Cart",

    data() {
      return {
        alerts: [],
        cart: {
          count: 0,
          items: [],
          samples: 0,
          subtotal: 0.0,
          yardage: 0.0,
        },
        isAddMemoLoading: false,
        isDirty: false,
        loading: true,
        processing: [],
      };
    },

    async mounted() {
      await this.fetchCart();
    },

    methods: {
      addMemo(event) {
        if (document.querySelector('[name="memo_sku"]').value === "") {
          return;
        }

        this.isAddMemoLoading = true;

        let data = new FormData();
        data.append("sku[0]", document.querySelector('[name="memo_sku"]').value);
        data.append("quantity[0]", document.querySelector('[name="memo_qty"]').value || 1);
        data.append("warehouse[0]", "03");
        data.append("return", "alert");

        this.clearAlerts();

        this.$http
          .post("/cart/add", data)
          .then((response) => {
            this.reloadCart();

            this.alerts.push(new Alert(response.data.html, "append-memo-alert"));

            document.querySelector('[name="memo_sku"]').value = "";
            document.querySelector('[name="memo_qty"]').value = "";
          })
          .catch((error) => {
            let response = error.response;

            this.alerts.push(new Alert(response.data.html, "append-memo-alert"));
          })
          .finally(() => {
            this.isAddMemoLoading = false;
          });
      },

      alterProcessing(sku, state) {
        const index = this.processing.indexOf(sku);

        if (!state && index !== -1) {
          setTimeout(() => {
            this.processing.splice(this.processing.indexOf(sku), 1);
          }, 500);

          return;
        }

        if (index !== -1) {
          return;
        }

        this.processing.push(sku);
      },

      checkProceed(event) {
        if (this.processing.length > 0 || this.loading) {
          event.preventDefault();
        }
      },

      clearAlerts() {
        this.alerts.forEach((alert, i) => {
          alert.destroy();

          this.alerts.splice(i, 1);
        });
      },

      async fetchCart() {
        await this.$http
          .get("/cart/fetch?timestamp=" + new Date().getTime())
          .catch((error) => window.console.error(error.response))
          .then((response) => {
            response.data.cart && Object.assign(this.cart, response.data.cart);

            if (response.data.message) {
              this.alerts.push(
                new Alert(response.data.message, "cart-mount", {
                  autoDestroy: false,
                  prepend: true,
                })
              );
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async reloadCart() {
        await this.fetchCart();
      },

      async removeItem(item) {
        this.cart.items.splice(this.cart.items.indexOf(item), 1);

        await this.reloadCart();
      },

      setClean() {
        this.isDirty = false;
      },

      setDirty() {
        this.isDirty = true;
      },
    },

    computed: {
      canProceed() {
        return this.processing.length === 0 && !this.loading;
      },
    },

    render() {
      return this.$scopedSlots.default({
        addMemo: this.addMemo,
        alterProcessing: this.alterProcessing,
        cart: this.cart,
        checkProceed: this.checkProceed,
        isAddMemoLoading: this.isAddMemoLoading,
        isDirty: this.isDirty,
        loading: this.loading,
        moneyFormat: moneyFormat,
        canProceed: this.canProceed,
        reloadCart: this.reloadCart,
        removeItem: this.removeItem,
        setClean: this.setClean,
        setDirty: this.setDirty,
      });
    },
  };
</script>
